import * as React from 'react';
import { get } from '../helpers/http';
import * as actionTypes from '../consts/actionTypes';
import { searchWizardPage as searchWizardPageType } from '../consts/pageTypes';
import { changeRouteSuccess } from './routerActions';
import { __ } from '../helpers/TranslationService';
import { defaultSeo } from '../reducers/pageData';

import loadable from '@loadable/component';
import { getRouteSlugs } from '../helpers/routing';

export const searchWizardPageRouteAction = (context) => {
    let urlParams = context.url.substr('kreuzfahrt-finden/'.length);
    urlParams =
        urlParams[urlParams.length - 1] === '/'
            ? urlParams.substring(0, urlParams.length - 1)
            : urlParams;
    const storeState = context.store.getState();

    const { appConfig, brandConfig, config } = storeState.pageData;
    const { apiHost } = appConfig;

    const { slugs: slugsArr } = brandConfig;
    const slugs = getRouteSlugs(slugsArr);
    const searchWizardSlug = slugs['searchWizardPage'] || '';

    const { contentEndpoint } = config;

    let { path, params, baseUrl, waitForAction, action } = context;

    const defaultActions = (title = null) => {
        const pageTitle = title
            ? title
            : __('Cruise-Finder - Find your dream cruise with Dreamlines', 'dreamlines');
        const seo = defaultSeo;
        seo.titleOg = pageTitle;
        seo.canonical = `${contentEndpoint}/${searchWizardSlug}`;
        seo.metadesc = __('Cruise-Finder meta description', 'dreamlines');
        context.store.dispatch(
            changeRouteSuccess({
                path,
                params,
                baseUrl,
                action,
                pageTitle,
                pageType: searchWizardPageType,
                seo,
            }),
        );

        const SearchWizardPage = loadable(() => import('../pages/SearchWizard/SearchWizardPage'));

        return { component: <SearchWizardPage />, context };
    };

    if (waitForAction) {
        return Promise.all(
            [
                get(`${apiHost}/wizard/questions?platform=mobile`),
                get(`${apiHost}/page/v2${urlParams}`),
            ].map(P),
        )
            .then(([wizardQuestionsResponse, pageDetailsResponse]) => {
                const formattedWizardQuestionsResponse =
                    pageDetailsResponse[0] === undefined
                        ? wizardQuestionsResponse
                        : pageDetailsResponse[0].pageType === 'lpCompanyDetail' ||
                          pageDetailsResponse[0].pageType === 'ship_detail'
                        ? wizardQuestionsResponse
                        : {
                              startScreen: wizardQuestionsResponse.startScreen,
                              questions: wizardQuestionsResponse.questions.slice(1),
                          };
                context.store.dispatch({
                    type: actionTypes.loadSearchWizardData,
                    payload: {
                        ...formattedWizardQuestionsResponse,
                        pageDetails: pageDetailsResponse[0],
                    },
                });
                return defaultActions();
            })
            .catch((error) => {
                console.log(error);
            });
    } else {
        return defaultActions();
    }
};

const P = (p: Promise<any>): any => {
    return p.then(
        (f) => ({ ...f }),
        (r) => ({ ...r }),
    );
};
